import AxiosPipeline from '@/services/api/pipeline/axios_pipeline'

export default {
  createRoutine: (data) => {
    return AxiosPipeline.post('routine', data)
  },

  updateRoutine: (routineId, data) => {
    return AxiosPipeline.put(`routine/${routineId}`, data)
  },

  getAllRoutines: (params) => {
    return AxiosPipeline.get('routine', {params})
  },

  getRoutine: (routineId) => {
    return AxiosPipeline.get(`routine/${routineId}`)
  },

  getRoutinesByServer: (serverId) => {
    return AxiosPipeline.get(`routine/server/${serverId}`)
  },

  prepareRoutine: (serverId, routineId, data) => {
    return AxiosPipeline.post(`server/${serverId}/routine/${routineId}/prepare`, data)
  },

  deleteRoutine: (routineId) => {
    return AxiosPipeline.delete(`routine/${routineId}`)
  }
}
